#import '../../../../shared/graphql/fragments/lead-step-fragment.graphql'

mutation UpdateStepForLead($input: StepUpdateInput!) {
    stepUpdate(input: $input) {
        step {
            ...LeadStepFragment
        }
    }
}
